require('ub/config/raven-base-config.js'); // adds to window.xxx

var Raven = require('raven-js');
var _ = require('lodash');
var ubBanzai = require('ub/control/banzai-features');
var Rx = require('ub_wrapped/rx');
var errorNotifierSubject = new Rx.Subject();
var ajaxAsObservable = require('ub/control/ajax-as-observable');
var rxUi = require('ub/control/rx-ui');

var _sendRxTraceDataToS3Observable = function(errorEvent) {
  var postData = {
    page_id: window.editor.mainPage.uuid,
    event_data: rxUi.eventBus.ringBuffer.buffer
  };

  if (ubBanzai.features.isRecordRxUIEventsEnabled()) {
    postData.event_data = rxUi.eventBus.eventLog;
  }

  return ajaxAsObservable({
      type: "POST",
      headers: {
        "x-api-key": 'G35K46TWvV7SrKqXTm8oV9UGzGh9M7lP7KzYT1HQ'
      },
      url: "https://ewv7ofclt6.execute-api.us-east-1.amazonaws.com/production/rx-ui-events",
      data: JSON.stringify(postData)
    })
    .map(function(response) {
      var result = _.clone(errorEvent);
      if (response.data.url) {
        result.rxTraceData = response.data.url;
      }
      return result;
    }).catch();
};

var _setupSendEventsToS3Subscription = function(errorNotifier) {
  var dispatchTable = {
    message: errorNotifier._captureMessage.bind(errorNotifier),
    exception: errorNotifier._captureException.bind(errorNotifier)
  };

  // This is the flow when we dont want the s3 url with rx trace
  var normalObservable = errorNotifierSubject
    .filter(function() {
      return ! window.editor ||
        (window.editor && ! window.editor.mainPage);
    });

  // This is the flow when we want the s3 url with rx trace
  var attachRxTraceUrlObservable = errorNotifierSubject
    .filter(function() {
      return window.editor && window.editor.mainPage;
    })
    .concatMap(function(errorEvent) {
      return _sendRxTraceDataToS3Observable(errorEvent);
    });

  var observable = Rx.Observable.merge(normalObservable, attachRxTraceUrlObservable);

  observable.subscribe(function(errorEvent) {
    if(! _.isEmpty(errorEvent.rxTraceData)) {
      window.ravenDataCallbackHooks.push(function(data) {
        data.extra.rx_ui_trace = errorEvent.rxTraceData;
      });
    }
    dispatchTable[errorEvent.type](errorEvent.payload, errorEvent.options);
  });
};

var ErrorNotifier = function() {
  this._errorContextStack = [];
  this._userContext = {};
  return this;
};

ErrorNotifier.prototype = (function(){
  return {
    _initRavenGlobalContext: function() {
      this._baseContext = _.merge(
        {},
        (window.RavenBaseContext || {}),
        {extra:{},
         tags: {
          lp_context: window.lp_raven_context,
          editor_version       : window.builderVersion || 'dev',
          undo_manager_execute : false
        }});
      this._resetRavensBaseContext();
    },

    addTagsToBaseContext: function(tags) {
      // public api for adding extra tags after the error notifier
      // is instantiated. The editor object does this.
      this._baseContext.tags = _.merge(this._baseContext.tags, tags);
      this._resetRavensBaseContext();
    },

    _resetRavensBaseContext: function() {
      // The Raven context passed into captureException/Message
      // affects the normal context as set by Raven.setTagsContext
      // so we must reset it after each call
      Raven.setTagsContext(JSON.parse(JSON.stringify(this._baseContext.tags)));
    },

    pushErrorContext: function(context) {
      this._errorContextStack.push(context);
      return this;
    },

    popErrorContext: function() {
      return this._errorContextStack.pop();
    },

    setUserContext: function(context) {
      //TODO: check if Raven is merging this data in or if it
      //overwrites existing context. Suspect it's overwriting.
      this._userContext = JSON.parse(JSON.stringify(context));
      Raven.setUserContext(context);
      return this;
    },

    _getErrorStackContext: function(options){
      return _.reduce(_.flatten([this._baseContext,
                          this._errorContextStack,
                          options]),
               _.merge,
               {});
    },

    captureException: function(error, options) {
      errorNotifierSubject.onNext({
        type: 'exception',
        payload: error,
        options: options
      });
    },

    _captureException: function(error, options) {
      Raven.captureException(error, this._getErrorStackContext(options));
      this._resetRavensBaseContext(); // do not remove, see comment in resetBaseContext
      return this;
    },

    captureMessage: function(message, options) {
      errorNotifierSubject.onNext({
        type: 'message',
        payload: message,
        options: options
      });
    },

    _captureMessage: function(message, options) {
      Raven.captureMessage(message, this._getErrorStackContext(options));
      this._resetRavensBaseContext(); // do not remove, see comment in resetBaseContext
      return this;
    },

    install: function() {
      if (window.RavenStub) {
        // This is a temp thing until we can figure out why Raven really
        // doesn't like giving up the namespace in testing.
        window.Raven = new window.RavenStub();
      } else {
        this._initRavenGlobalContext();
        if (window.gon && window.gon.user) {
          this.setUserContext(window.gon.user);
        }
      }
      _setupSendEventsToS3Subscription(this);
      return this;
    }
  };
})();

module.exports = ErrorNotifier;



// WEBPACK FOOTER //
// ./src/control/error_notifier.js